// extracted by mini-css-extract-plugin
module.exports = {"container":"NavbarDesktop_container__3_T-5","list":"NavbarDesktop_list__2Me5o","navlink":"NavbarDesktop_navlink__12NdB","active":"NavbarDesktop_active__WZHP9"};